import { useEffect } from 'react';
import Navbar from '../../Utils/Navbar/navbar-component.js'
import Footer from '../../Utils/Footer/footer-component.js'
import Layout from '../../Utils/Navbar/navbar-layout-component.js';
import Products from './Products.js';
import Contact from '../Contact-screen/Contact.js';

function ProductsScreen() {

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (
        <div className="flex w-full flex-col">
            <div>
                <Layout>
                    <Products />
                    <Contact/>
                </Layout>
                <Footer />
            </div>

        </div>
    );
}

export default ProductsScreen;